const BASE_URL = process.env.PURCHASE_PAYMENTS_API_URL;

export const PAYMENT_METHOD_ENDPOINTS = {
  GET_PAYMENT_METHOD_SUMMARY: `${BASE_URL}/api/v1/payment-method/summary`,
  SELECT_BANK_ACCOUNT: `${BASE_URL}/api/v1/payment-method/select-bank-account`,
  SELECT_CARD: `${BASE_URL}/api/v1/payment-method/select-card`,
  SELECT_DIGITAL_WALLET: `${BASE_URL}/api/v1/payment-method/select-digital-wallet`
} as const;

export const BANK_ACCOUNT_ENDPOINTS = {
  CREATE_PLAID_LINK_TOKEN: `${BASE_URL}/api/v1/bank-accounts/create-plaid-link-token`,
  ADD_BANK_ACCOUNT: `${BASE_URL}/api/v1/bank-accounts/add-bank-account`,
  ADD_BANK_ACCOUNT_FROM_PLAID: `${BASE_URL}/api/v1/bank-accounts/add-bank-account-from-plaid`
} as const;

export const CARD_ENDPOINTS = {
  CREATE_STRIPE_SETUP_INTENT: `${BASE_URL}/api/v1/cards/create-stripe-setup-intent`,
  ADD_CARD_FROM_STRIPE: `${BASE_URL}/api/v1/cards/add-card-from-stripe`
} as const;
